var map = {
	"./Aboutus-doctor.jpg": "./assets/img/Aboutus-doctor.jpg",
	"./Surescripts_certified-lowres.jpg": "./assets/img/Surescripts_certified-lowres.jpg",
	"./Surescripts_certified-transparent.png": "./assets/img/Surescripts_certified-transparent.png",
	"./Surescripts_certified-white.png": "./assets/img/Surescripts_certified-white.png",
	"./about-icon.png": "./assets/img/about-icon.png",
	"./all-appointments.png": "./assets/img/all-appointments.png",
	"./appointments.jpg": "./assets/img/appointments.jpg",
	"./appointments.png": "./assets/img/appointments.png",
	"./banner-1.png": "./assets/img/banner-1.png",
	"./banner-2.jpg": "./assets/img/banner-2.jpg",
	"./banner-3.jpg": "./assets/img/banner-3.jpg",
	"./blank.png": "./assets/img/blank.png",
	"./blog-1.jpg": "./assets/img/blog-1.jpg",
	"./blog-2.jpg": "./assets/img/blog-2.jpg",
	"./blog-3.jpg": "./assets/img/blog-3.jpg",
	"./blog-4.jpg": "./assets/img/blog-4.jpg",
	"./cancel.png": "./assets/img/cancel.png",
	"./customer.jpg": "./assets/img/customer.jpg",
	"./daughter.jpg": "./assets/img/daughter.jpg",
	"./doc-slide-1.png": "./assets/img/doc-slide-1.png",
	"./docs.jpg": "./assets/img/docs.jpg",
	"./doctor-banner1.png": "./assets/img/doctor-banner1.png",
	"./doctor-consult.jpg": "./assets/img/doctor-consult.jpg",
	"./doctor.jpg": "./assets/img/doctor.jpg",
	"./dr-slider.png": "./assets/img/dr-slider.png",
	"./father.jpg": "./assets/img/father.jpg",
	"./favicon.png": "./assets/img/favicon.png",
	"./featured-bg.jpg": "./assets/img/featured-bg.jpg",
	"./finance.jpg": "./assets/img/finance.jpg",
	"./footer-logo-top.png": "./assets/img/footer-logo-top.png",
	"./footer-logo.png": "./assets/img/footer-logo.png",
	"./google-map.png": "./assets/img/google-map.png",
	"./home-doctor.png": "./assets/img/home-doctor.png",
	"./home_doctor.jpg": "./assets/img/home_doctor.jpg",
	"./icon-01.png": "./assets/img/icon-01.png",
	"./icon-02.png": "./assets/img/icon-02.png",
	"./icon-03.png": "./assets/img/icon-03.png",
	"./idp-terms.png": "./assets/img/idp-terms.png",
	"./img-01.jpg": "./assets/img/img-01.jpg",
	"./img-02.jpg": "./assets/img/img-02.jpg",
	"./img-03.jpg": "./assets/img/img-03.jpg",
	"./img-04.jpg": "./assets/img/img-04.jpg",
	"./img-pharmacy1.jpg": "./assets/img/img-pharmacy1.jpg",
	"./invoice.png": "./assets/img/invoice.png",
	"./lab-image.jpg": "./assets/img/lab-image.jpg",
	"./lab-test.jpg": "./assets/img/lab-test.jpg",
	"./location.png": "./assets/img/location.png",
	"./login-banner.png": "./assets/img/login-banner.png",
	"./login-btn.png": "./assets/img/login-btn.png",
	"./logo-top.png": "./assets/img/logo-top.png",
	"./logo.png": "./assets/img/logo.png",
	"./marker.png": "./assets/img/marker.png",
	"./medical-img1.jpg": "./assets/img/medical-img1.jpg",
	"./medical-img2.jpg": "./assets/img/medical-img2.jpg",
	"./medical-img3.jpg": "./assets/img/medical-img3.jpg",
	"./medicines.jpg": "./assets/img/medicines.jpg",
	"./mobile-1.png": "./assets/img/mobile-1.png",
	"./mobile.png": "./assets/img/mobile.png",
	"./mother.jpg": "./assets/img/mother.jpg",
	"./patient-img.jpg": "./assets/img/patient-img.jpg",
	"./patient.jpg": "./assets/img/patient.jpg",
	"./prescription.png": "./assets/img/prescription.png",
	"./process.jpg": "./assets/img/process.jpg",
	"./process.png": "./assets/img/process.png",
	"./registration.jpg": "./assets/img/registration.jpg",
	"./search-bg.png": "./assets/img/search-bg.png",
	"./search.png": "./assets/img/search.png",
	"./secure.jpg": "./assets/img/secure.jpg",
	"./slide1.jpg": "./assets/img/slide1.jpg",
	"./slide2.jpg": "./assets/img/slide2.jpg",
	"./slider-bg.jpg": "./assets/img/slider-bg.jpg",
	"./son.jpg": "./assets/img/son.jpg",
	"./special-banner.jpg": "./assets/img/special-banner.jpg",
	"./specialist-bg.jpg": "./assets/img/specialist-bg.jpg",
	"./upload-icon.png": "./assets/img/upload-icon.png",
	"./video-call.jpg": "./assets/img/video-call.jpg",
	"./waiting.png": "./assets/img/waiting.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/img sync \\.png$%7C\\.jpg$";